import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import PropTypes from "prop-types";
import React from "react";
import {useTableWithCheckboxesHeadStyles} from "./CustomTableHeaderStyles";
import { Tooltip } from "@material-ui/core";
import { Help } from "@material-ui/icons";
import { colors } from "shared/colors";

function TableWithCheckboxHead(props) {
    const {onSelectAllClick, numSelected, rowCount, headCells} = props;
    const classes = useTableWithCheckboxesHeadStyles();
    return (
        <TableHead>
            <TableRow className={classes.root}>
                <TableCell padding="checkbox">
                    <Checkbox
                        disabled={props.canSelectAll}
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{'aria-label': 'select all'}}
                    />
                </TableCell>
                {headCells.map((column) => (
                    <TableCell
                        key={"head-cell-" + column.id}
                        align={column.align}
                        style={{paddingLeft: column.paddingLeft, width: column.width, minWidth: column.width}}
                    >
                        {column.label}
                        {column.tooltipLabel ?
                            <Tooltip title={column.tooltipLabel} >
                                <Help fontSize={"small"} style={{color: colors.primary.dark, marginLeft:"5px", transform: "translateY(5px)"}}/>
                            </Tooltip> : null
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}


TableWithCheckboxHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
    headCells: PropTypes.array.isRequired,
    canSelectAll: PropTypes.bool.isRequired
};

export default TableWithCheckboxHead;
